module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/whitecase_57be47.png";